import { useMutation } from '@tanstack/react-query';

import type { RegisterUserRequest } from '../../api/register-user/registerUser.types';
import type { UseRegisterUserResult } from './useRegisterUser.types';

import { registerUser } from '../../api/register-user/registerUser';

export function useRegisterUser(): UseRegisterUserResult {
  return useMutation<void, Error, RegisterUserRequest>({
    mutationFn: (data: RegisterUserRequest) => registerUser(data),
  });
}
